import { useTypedQuery } from "hooks";
import { DealersDashboardQueryKeys } from "modules/DealersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DealerID } from "models";

export const useDealerDetailsQuery = (dealerId?: DealerID) =>
  useTypedQuery({
    queryKey: DealersDashboardQueryKeys.dealerDetails(dealerId),
    queryFn: async ({ endpoint, baseUrl, params }) => (await ApiInstance.post(endpoint, params, baseUrl)).data,
    enabled: !!dealerId
  });
